import Vue from 'vue'
import Vuex from 'vuex'
import {state, getters, mutations} from './root'
import teaching from './modules/teaching'
// import products from './modules/products'

Vue.use(Vuex)

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    modules: {
        teaching,
    }
})

function initStates() {
    const matches = /[?&](cid|course_id)=(.*?)(&|$)/.exec(location.href) || [];
    if (matches[2]) {
        store.state.currentCourseId = Number.parseInt(matches[2]);
    }
}
initStates();

function normalLevel(level) {
    return Number.parseInt(String(level).substr(-2));
}

Vue.prototype.$normalLevel = normalLevel;
Vue.prototype.$formatLevel = (level) => {
    return store.state.currentCourseId * 100 + normalLevel(level);
};

export default store